import { createContext, useContext } from "react";
/**
 * Create a side-effect-free context provider so custom controls can handle updates.
 */ class CustomControlContextFactory {
    static Context() {
        return this.context = this.context || /*#__PURE__*/ createContext({});
    }
}
function useCustomControl() {
    return useContext(CustomControlContextFactory.Context());
}
export { CustomControlContextFactory, useCustomControl };
